import React, { type ReactNode, useSyncExternalStore } from 'react';

import { StatusAnnouncement } from './status-announcement';
import StatusAnnouncementProviderContext from './status-announcement-provider-context';
import statusAnnouncementStore from './status-announcement-store';

/**
 * Renders the persistent entry-point live region during server rendering.
 * Place this alongside the application's Relay environment provider so the
 * empty region exists before any client-side status updates.
 */
export function EntryPointStatusAnnouncementProvider({
	children,
}: {
	children: ReactNode;
}): React.JSX.Element {
	const text = useSyncExternalStore(
		statusAnnouncementStore.subscribe,
		statusAnnouncementStore.getSnapshot,
		statusAnnouncementStore.getServerSnapshot,
	);

	return (
		<StatusAnnouncementProviderContext.Provider value>
			<div data-entry-point-status-announcement="true">
				<StatusAnnouncement>{text}</StatusAnnouncement>
			</div>
			{children}
		</StatusAnnouncementProviderContext.Provider>
	);
}
